import { useQuery } from "@tanstack/react-query";
import { getSupplierClarifications } from "../api/final-scoring-api";

export const useSupplierClarifications = (
	rfxId: number,
	evalId: number,
	inviteId: number
) =>
	useQuery({
		queryKey: ["supplier-clarifications", rfxId, evalId, inviteId],
		queryFn: () => getSupplierClarifications(rfxId, evalId, inviteId),
		staleTime: 5 * 60 * 1000,
		enabled: !!rfxId && !!evalId && !!inviteId,
	});
